import { render } from "./SearchFilterView.vue?vue&type=template&id=047dcb8e&scoped=true"
import script from "./SearchFilterView.vue?vue&type=script&lang=js"
export * from "./SearchFilterView.vue?vue&type=script&lang=js"

import "./SearchFilterView.vue?vue&type=style&index=0&id=047dcb8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047dcb8e"]])

export default __exports__